import { Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { href: '#about', label: 'About' },
    { href: '#services', label: 'Services' },
    { href: '#expertise', label: 'Expertise' },
    { href: '#why-vantaris', label: 'Why Vantaris' },
    { href: '#insights', label: 'Insights' },
    { href: '#contact', label: 'Contact' },
  ];

  const handleAnchor = (e, hash) => {
    e.preventDefault();
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer data-testid="main-footer" className="bg-[#130723] text-white border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8 items-start">
          {/* Wordmark */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <img
                src="/brand/vantaris-icon.png"
                alt=""
                aria-hidden="true"
                className="h-10 w-10 object-contain"
              />
              <div className="flex items-baseline gap-2">
                <span className="font-display text-2xl font-semibold text-white tracking-tight">Vantaris</span>
                <span className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-medium">Integrated Solutions</span>
              </div>
            </div>
            <p className="mt-5 text-sm text-slate-400 max-w-xs leading-relaxed">
              Physician-Led. Community-Centered. Systems-Focused.
            </p>
          </div>

          {/* Nav */}
          <div className="md:col-span-5">
            <h4 className="text-[11px] font-medium uppercase tracking-[0.22em] text-[#D4AF37] mb-5">
              Navigate
            </h4>
            <nav className="grid grid-cols-2 gap-3">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={(e) => handleAnchor(e, l.href)}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="text-sm text-slate-300 hover:text-[#E5C75B] transition-colors"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <h4 className="text-[11px] font-medium uppercase tracking-[0.22em] text-[#D4AF37] mb-5">
              Connect
            </h4>
            <p className="text-sm text-slate-300 mb-2">Flint, Michigan</p>
            <a
              href="mailto:jgill@vantarisadvisory.com"
              data-testid="footer-email"
              className="text-sm text-slate-300 hover:text-[#E5C75B] transition-colors block mb-1"
            >
              jgill@vantarisadvisory.com
            </a>
            <a
              href="tel:+18102284975"
              data-testid="footer-phone"
              className="text-sm text-slate-300 hover:text-[#E5C75B] transition-colors block mb-4"
            >
              (810) 228-4975
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center justify-center w-9 h-9 border border-white/15 text-slate-300 hover:text-[#1B0E33] hover:bg-[#D4AF37] hover:border-[#D4AF37] transition-all"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500 tracking-wide">
            © {currentYear} Vantaris Integrated Solutions. All Rights Reserved.
          </p>
          <p className="text-xs text-slate-500 italic">
            Physician-Led. Community-Centered. Systems-Focused.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
